import { createSlice } from '@reduxjs/toolkit';
import { initialBuilderPageInfo } from 'builder/common/builderData';

const initialState = {
  adminType: null,
  builderType: null,
  builderId: null,
  settingId: null,
  setting: {
    responsive: {
      isMobile: true,
      isTab: false,
      isWeb: false,
      isPopup: false,
    },
    headerInfo: {
      headerPosition: "sticky",
      headerBackground: "#ffffff"
    }
  },
};

export const builderSettingSlice = createSlice({
  name: 'builderSetting',
  initialState,
  reducers: {
    setInitialBuilderSettings: (state, action) => {
      return initialState
    },
    setBuilderSettings: (state, action) => {
      state.adminType = action.payload.adminType;
      state.builderType = action.payload.builderType;
      state.builderId = action.payload.id;
      state.settingId = action.payload.settings
        ? action.payload.settings?._id
        : null;
      state.setting = action.payload.settings ? action.payload.settings : null;
    },
    updatePageBuilderSettings: (state, action) => {
      if (!state.setting.pageInfo) {
        state.setting = {
          ...state.setting,
          pageInfo: initialBuilderPageInfo,
        };
      }
      if (action.payload.meta) {
        state.setting = {
          ...state.setting,
          pageInfo: {
            ...state.setting.pageInfo,
            meta: {
              ...state.setting.pageInfo.meta,
              [action.payload.key]: action.payload.value,
            },
          },
        };
      } else {
        state.setting = {
          ...state.setting,
          pageInfo: {
            ...state.setting.pageInfo,
            [action.payload.key]: action.payload.value,
          },
        };
      }
    },
    updatePageTitleSettings: (state, action) => {


      if (!state.setting.pageInfo) {
        state.setting = {
          ...state.setting,
          pageInfo: { ...initialBuilderPageInfo, slug: action.payload.slug || null, pageName: action.payload.name || null, pageTitle: action.payload.name || null },
        }
      }
      else {
        state.setting = {
          ...state.setting,
          pageInfo: { ...state.setting.pageInfo, slug: action.payload.slug, pageName: action.payload.name, pageTitle: action.payload.name },
        };
      }

    },
    updateBuilderPageType: (state, action) => {

      state.builderType = action.payload.type;

    },
    updateHeaderBuilderSettings: (state, action) => {
      state.setting = {
        ...state.setting,
        responsive: {
          ...state.setting.responsive,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    updateHeaderColorSettings: (state, action) => {
      state.setting = {
        ...state.setting,
        headerInfo: {
          ...state.setting.headerInfo,
          headerBackground: action.payload,
        },
      };
    },
    updateHeaderPositionSettings: (state, action) => {
      state.setting = {
        ...state.setting,
        headerInfo: {
          ...state.setting.headerInfo,
          headerPosition: action.payload,
        },
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setBuilderSettings,
  updatePageBuilderSettings,
  updateHeaderBuilderSettings,
  updateHeaderColorSettings,
  updateHeaderPositionSettings,
  setInitialBuilderSettings,
  updatePageTitleSettings,
  updateBuilderPageType
} = builderSettingSlice.actions;

export default builderSettingSlice.reducer;
